<template>
    <section>
        <div v-if="loading">
            <Loading />
        </div>
        <div v-else>
            <section>
                <Nav/>
                <section class="card-container">
                    <h1>{{ $t('medals_page.title') }}</h1>
                    <p>{{ $t('medals_page.intro') }}</p>
                    <ul class="cards" 
                        v-if="results.length > 0"
                        :class="{'grid': results.length > 1, 'small-grid': results.length < 4}">
                        <MedalCard v-for="item in results" v-bind:key="item.id" :model="item"></MedalCard>
                    </ul>
                    <p v-else class="no-results">{{ $t('labels.no_results') }}</p>
                </section>
            </section>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

import Loading from '@/components/Loading'
import MedalCard from "@/components/MedalCard"
import Nav from '@/components/Nav'

export default {
    components: {
        Loading,
        Nav,
        MedalCard
    },
    computed: {
        ...mapGetters({
            'results': 'medals/list_results',
            'loading': 'medals/list_loading'
        })
    },
    methods: {
        search : function(e) {
            this.$store.dispatch("medals/search", e.target.value)
        }
    },
    head: {
        title: function() {
            return {
                inner: this.$i18n.t('medals_page.title'),
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.$i18n.t('medals_page.intro'), id: 'desc'},

                {property: 'og:title', content: `${this.$i18n.t('medals_page.title')} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.$i18n.t('medals_page.intro'), id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: `${window.location.host}${this.$i18n.t('medals_page.preview_image')}`, id: 'og-image'}
            ]
        }
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                let query = Object.assign({}, this.$route.query);
                this.$store.dispatch('medals/search', query.q)
            }
        }
    },
    async mounted() {
        await this.$store.dispatch("medals/clear_search")

        await this.$store.dispatch("medals/fetch_list", {
            locale: this.$i18n.locale
        })

        if ("q" in this.$route.query) {
            this.$store.dispatch('medals/search', this.$route.query.q)
        }
    },
}
</script>

<style lang="scss" scoped>
.cards.grid {
    grid-template-columns: repeat(auto-fit, minmax(410px, 1fr));

    &.small-grid {
        grid-template-columns: repeat(auto-fit, 410px);
        @media screen and (max-width: 1056px) {
            grid-template-columns: repeat(auto-fit, minmax(410px, 1fr));
        }
    }

    @media screen and (max-width: 1025px) {
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
        grid-gap: 10px;
    }
    @media screen and (max-width: 831px) {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: 10px;
    }
    @media screen and (max-width: 420px) {
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    }
}

@media screen and (max-width: 1025px) {
    .card-container {
        padding-left: 20px;
        padding-right: 20px;
    }
}
</style>